import type { Article } from './types';

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    slug: 'dingliu-nanxing-shenye-mihui',
    excerpt: '据可靠消息，某当红顶流男星近日被拍到深夜与一位神秘女子共进晚餐，两人举止亲密，引发网友热议。',
    content: `<p>近日，有网友在某高档餐厅偶遇当红顶流男星李某与一位神秘女子共进晚餐。据目击者描述，两人举止亲密，相谈甚欢，整个用餐过程持续了将近三个小时。</p><p>据知情人士透露，该神秘女子并非圈内人，而是一位从事金融行业的精英。两人是通过共同朋友介绍认识的，目前已经交往了一段时间。</p><p>值得一提的是，李某此前在多个公开场合均表示自己单身，此次被拍到与女性友人亲密约会，让不少粉丝直呼"房子塌了"。截至目前，李某的工作室尚未对此事作出任何回应。</p><p>粉丝反应两极分化，一部分粉丝送上祝福，希望偶像能够获得幸福；另一部分粉丝则情绪激动，在社交平台上表达了不满。</p><p>业内人士分析认为，作为顶流艺人，公开恋情确实需要勇气，但从长远来看，真诚面对粉丝反而能够赢得更多尊重。</p>`,
    category: 'mingxing-bagua',
    author: '吃瓜小编',
    publishedAt: '2026-08-05T10:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20in%20black%20suit%20walking%20with%20mysterious%20woman%20at%20night%20outside%20luxury%20restaurant%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20dramatic%20atmosphere%2C%20cinematic%20noir%20aesthetic&width=800&height=533&seq=article-1&orientation=landscape',
    tags: ['顶流男星', '恋情曝光', '深夜约会'],
    views: 128500,
    comments: 3652,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '2',
    title: '热门综艺录制现场突发意外，导演组紧急叫停',
    slug: 'zongyi-luzhi-yiwai-tingbo',
    excerpt: '某热门综艺节目录制过程中发生意外事故，导致一名嘉宾受伤，节目组已紧急暂停录制并展开调查。',
    content: `<p>据现场工作人员透露，某热门卫视综艺节目在昨日录制过程中突发意外。一位参与录制的嘉宾在进行户外挑战环节时不幸摔倒受伤，节目组立即启动应急预案，停止了当天的录制工作。</p><p>该嘉宾随后被送往附近医院进行检查，经诊断为轻微扭伤，目前已无大碍。节目组表示将承担全部医疗费用，并对录制流程进行全面安全检查。</p><p>此事在业内引发广泛讨论，不少网友对综艺节目的安全措施提出了质疑。有业内人士表示，为了追求收视率，部分节目在设计环节时确实存在过度追求刺激的问题。</p><p>该节目制片人随后发表声明，向受伤嘉宾及观众致歉，承诺将全面整改安全流程，确保类似事件不再发生。</p>`,
    category: 'zongyi-jieMu',
    author: '综艺观察员',
    publishedAt: '2026-08-04T16:45:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20set%20with%20cameras%20and%20lighting%20equipment%20in%20Chinese%20studio%2C%20crew%20members%20rushing%20around%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20documentary%20style%2C%20warm%20studio%20lighting&width=800&height=533&seq=article-2&orientation=landscape',
    tags: ['综艺录制', '意外事故', '嘉宾受伤'],
    views: 89200,
    comments: 2145,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '3',
    title: '年度古装大剧定档八月，豪华阵容引爆期待',
    slug: 'guzhuang-daju-dingdang-bayue',
    excerpt: '备受瞩目的年度古装巨制正式宣布定档8月15日，超强演员阵容和精良制作引发全网期待。',
    content: `<p>由知名导演张某某执导的年度古装大剧《长安风云录》正式宣布定档8月15日，将在三大视频平台同步播出。该剧汇集了当下最具人气的中生代演员，阵容堪称豪华。</p><p>据悉，该剧总投资超过5亿元，拍摄周期长达8个月，辗转全国多个影视基地取景。制片方表示，无论是服化道还是特效制作，都力求达到电影级别的水准。</p><p>预告片发布后24小时内，全网播放量突破2亿次，话题阅读量超过15亿，充分展现了观众对这部作品的高度期待。</p><p>不过也有部分原著粉丝对选角表示担忧，认为某些角色与原著形象存在差距。对此，导演在发布会上表示，每位演员都经过了严格的试镜筛选，相信他们的表现能够征服观众。</p>`,
    category: 'yingshi-zixun',
    author: '影视前线',
    publishedAt: '2026-08-05T08:15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20actors%20in%20traditional%20hanfu%20robes%20standing%20in%20palace%20courtyard%2C%20cinematic%20lighting%2C%20grand%20historical%20setting%2C%20dramatic%20composition%2C%20film%20poster%20quality&width=800&height=533&seq=article-3&orientation=landscape',
    tags: ['古装大剧', '定档消息', '豪华阵容'],
    views: 156300,
    comments: 4821,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '4',
    title: '千万粉丝网红直播带货翻车，品牌方连夜解约',
    slug: 'wanghong-zhibo-fanche',
    excerpt: '拥有超过两千万粉丝的头部网红在直播带货中因产品质量问题遭遇信任危机，多个品牌方宣布终止合作。',
    content: `<p>拥有超过两千万粉丝的知名网红"甜心姐姐"在近日的一场直播带货中遭遇严重翻车。其推荐的一款美容仪产品被大量消费者投诉存在严重质量问题，甚至有多人反映使用后出现皮肤过敏反应。</p><p>事件发酵后，多个与该网红合作的品牌方连夜发布声明，宣布终止合作关系。据不完全统计，此次事件导致该网红在24小时内损失了超过2000万元的广告合同。</p><p>消费者权益保护协会已介入调查，要求涉事产品的生产商和销售方就产品质量问题做出说明。同时，直播平台也对该网红的账号进行了临时限制处理。</p><p>这起事件再次引发了对直播带货行业监管的讨论。有专家呼吁，平台应建立更严格的主播准入机制和产品质量审核流程，保障消费者权益。</p>`,
    category: 'wanghong-redian',
    author: '直播观察',
    publishedAt: '2026-08-04T14:20:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20in%20modern%20streaming%20studio%20with%20ring%20lights%20and%20products%20on%20table%2C%20worried%20expression%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20documentary%20style&width=800&height=533&seq=article-4&orientation=landscape',
    tags: ['网红翻车', '直播带货', '品牌解约'],
    views: 201400,
    comments: 7523,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '5',
    title: '知名歌手被曝婚变，双方社交平台已互相取关',
    slug: 'zhiming-geshou-hunbian',
    excerpt: '娱乐圈模范夫妻疑似感情破裂，知名歌手与其演员妻子社交平台互相取关，引发网友猜测。',
    content: `<p>娱乐圈又一对模范夫妻疑似感情破裂。有网友发现，知名歌手王某与其演员妻子张某在社交平台上已经互相取关，且两人最后一次公开互动停留在三个月前。</p><p>更令人玩味的是，张某在近日发布的一条动态中写道："新的开始，好好爱自己。"虽然并未明确指向感情问题，但在这个时间节点上发出这样的内容，不免让人浮想联翩。</p><p>两人于2018年结婚，育有一子，一直是圈内公认的恩爱夫妻。如果此次婚变传闻属实，无疑会让许多CP粉心碎。</p><p>截至目前，双方的经纪公司均未对此事做出回应。有消息称，两人目前已经分居，但尚未正式办理离婚手续。</p>`,
    category: 'mingxing-bagua',
    author: '八卦探员',
    publishedAt: '2026-08-03T18:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20walking%20apart%20on%20red%20carpet%2C%20elegant%20evening%20attire%2C%20distant%20expressions%2C%20paparazzi%20flash%20photography%2C%20dramatic%20red%20carpet%20scene%2C%20warm%20golden%20spotlights&width=800&height=533&seq=article-5&orientation=landscape',
    tags: ['歌手婚变', '互相取关', '感情破裂'],
    views: 175600,
    comments: 5891,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '6',
    title: '某选秀节目黑幕曝光：投票数据遭人为操控',
    slug: 'xuanxiu-heimu-puguang',
    excerpt: '前工作人员实名举报某选秀节目存在投票数据造假行为，节目组已启动内部调查。',
    content: `<p>一档正在热播的选秀节目被前工作人员实名举报存在投票数据造假行为。该工作人员在社交平台上发布长文，详细揭露了节目组如何通过技术手段操控观众投票数据。</p><p>据其爆料，节目组会在每轮投票结束后，根据内部既定方案对各选手的票数进行调整，以确保"合适"的选手能够晋级。这意味着粉丝们投入大量精力和金钱进行的投票，最终结果并非完全由他们决定。</p><p>此事曝光后，大量粉丝表达了强烈愤怒，要求节目组给出合理解释并退还投票费用。相关话题迅速登上热搜榜首。</p><p>节目制作方随后发布声明，对相关指控予以否认，并称已启动内部调查程序。但这一回应并未平息粉丝的怒火，反而引发了更大规模的质疑。</p>`,
    category: 'zongyi-jieMu',
    author: '选秀真相',
    publishedAt: '2026-08-03T11:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20talent%20show%20stage%20with%20contestants%20standing%20under%20dramatic%20spotlights%2C%20judges%20panel%20in%20background%2C%20voting%20screen%20with%20numbers%2C%20intense%20atmosphere%2C%20dark%20stadium%20setting&width=800&height=533&seq=article-6&orientation=landscape',
    tags: ['选秀黑幕', '数据造假', '实名举报'],
    views: 235100,
    comments: 8923,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '7',
    title: '某知名导演新片拍摄现场流出大量路透照',
    slug: 'zhiming-daoYan-lutou',
    excerpt: '备受期待的新片拍摄现场路透照在网上疯传，主演造型首次曝光引发热议。',
    content: `<p>由著名导演陈某执导的新片《迷雾之城》近日在重庆取景拍摄，大量现场路透照在社交平台上流出。照片中，主演赵某以全新造型亮相，与此前公众形象形成鲜明对比。</p><p>从路透照来看，赵某此次饰演的是一位落魄侦探，造型沧桑粗犷，与以往帅气形象截然不同。不少网友表示，这种突破性的尝试让人对影片更加期待。</p><p>不过，大量的路透照流出也引发了对剧组保密工作的质疑。有业内人士指出，过度的路透可能会影响影片上映后的新鲜感和观众的观影体验。</p><p>影片目前定于2027年春节档上映，制片方表示一切进展顺利，更多官方物料将在后续陆续发布。</p>`,
    category: 'yingshi-zixun',
    author: '片场直击',
    publishedAt: '2026-08-02T20:45:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20in%20Chinese%20city%20street%20with%20cameras%20and%20crew%2C%20actor%20in%20detective%20costume%20standing%20next%20to%20vintage%20car%2C%20foggy%20atmosphere%2C%20noir%20cinematography%20style%2C%20behind%20the%20scenes%20documentary&width=800&height=533&seq=article-7&orientation=landscape',
    tags: ['电影路透', '主演造型', '拍摄现场'],
    views: 92300,
    comments: 2789,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '8',
    title: '某女星深夜发文疑暗讽同行，娱乐圈恩怨再升级',
    slug: 'nvxing-shenye-fawen',
    excerpt: '当红女星深夜在社交平台发布意味深长的文字，疑似回应近期与某同行的不和传闻。',
    content: `<p>当红女星林某于今日凌晨2点在社交平台发布了一段意味深长的文字："善良不等于好欺负，沉默不代表默认。有些事，不是不报，时候未到。"</p><p>这条动态发布后迅速引发粉丝和网友的疯狂解读。大多数人认为，这是在回应近期她与另一位女星之间的不和传闻。此前，有媒体爆料两人在某个活动后台发生口角，原因疑似与一部新戏的角色竞争有关。</p><p>有趣的是，被暗指的另一位女星在几小时后也发布了一条动态，配文"清者自清"，疑似隔空回应。这场隔空交锋让吃瓜群众大呼过瘾。</p><p>两位女星的粉丝也在评论区展开了激烈交锋，互相指责对方偶像"戏多"、"炒作"。这场娱乐圈的恩怨似乎还将继续发酵。</p>`,
    category: 'mingxing-bagua',
    author: '深夜吃瓜',
    publishedAt: '2026-08-02T03:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20actress%20in%20luxurious%20evening%20gown%20standing%20alone%20on%20balcony%20at%20night%2C%20city%20lights%20background%2C%20melancholic%20mood%2C%20cinematic%20portrait%20photography%2C%20warm%20ambient%20lighting&width=800&height=533&seq=article-8&orientation=landscape',
    tags: ['女星发文', '娱乐圈恩怨', '隔空回应'],
    views: 114200,
    comments: 4102,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '9',
    title: '某短视频平台AI换脸功能引发巨大争议',
    slug: 'duan-shipin-ai-huanlian',
    excerpt: '近日上线的AI换脸功能因涉及侵犯肖像权和隐私问题而引发广泛争议，多个明星工作室发函维权。',
    content: `<p>某头部短视频平台近日推出的AI换脸功能在短时间内引爆了社交媒体，但随之而来的是巨大的争议。该功能允许用户将自己的脸替换到各种视频素材中，包括明星的经典影视片段。</p><p>多个明星工作室已经向平台发函要求下架相关功能，认为这严重侵犯了艺人的肖像权。法律专家表示，未经许可使用他人肖像进行AI换脸，确实存在法律风险。</p><p>此外，该功能也引发了隐私安全方面的担忧。有安全研究员指出，用户上传的面部数据可能被用于训练AI模型，存在数据滥用的潜在风险。</p><p>面对铺天盖地的质疑，平台方已紧急下线了该功能的部分能力，并表示将重新评估功能设计，确保符合法律法规要求。</p>`,
    category: 'shehui-redian',
    author: '科技观察',
    publishedAt: '2026-08-01T15:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20AI%20face%20swap%20app%20interface%20with%20Chinese%20celebrity%20face%2C%20digital%20transformation%20effect%2C%20modern%20tech%20theme%2C%20purple%20and%20blue%20neon%20lighting%2C%20futuristic%20holographic%20style&width=800&height=533&seq=article-9&orientation=landscape',
    tags: ['AI换脸', '肖像权', '隐私争议'],
    views: 167800,
    comments: 5340,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '10',
    title: '年度悬疑剧口碑崩塌，编剧被网友怒批"烂尾"',
    slug: 'xuanyi-ju-koubei-tbengta',
    excerpt: '被寄予厚望的年度悬疑剧大结局播出后口碑崩塌，豆瓣评分从8.5暴跌至5.2，编剧遭网友怒批。',
    content: `<p>曾被观众寄予厚望的年度悬疑剧《迷局》在大结局播出后遭遇口碑滑铁卢。该剧前期以紧凑的剧情和精湛的演技获得了豆瓣8.5分的高评价，但最后两集的播出让一切急转直下。</p><p>大结局中，编剧给出了一个被观众普遍认为"敷衍"的结局——所有悬念最终被归因为主角的一场梦。这个"神转折"让追剧三个月的观众感到被愚弄，社交媒体上骂声一片。</p><p>编剧在社交平台上发文回应称，这个结局是"艺术表达的需要"，但这一解释并未获得观众谅解。大量观众涌入豆瓣给出一星评价，导致该剧评分在24小时内从8.5暴跌至5.2。</p><p>这起事件也引发了关于国产剧编剧质量的广泛讨论。有评论认为，国产悬疑剧在"开头惊艳"方面已经做得很好了，但在"完美收尾"方面仍有很大提升空间。</p>`,
    category: 'yingshi-zixun',
    author: '剧评人老张',
    publishedAt: '2026-08-01T21:15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20TV%20drama%20scene%20with%20detective%20character%20looking%20at%20evidence%20board%2C%20moody%20cinematography%2C%20film%20noir%20style%2C%20shadowy%20room%20with%20single%20desk%20lamp%2C%20tense%20atmosphere&width=800&height=533&seq=article-10&orientation=landscape',
    tags: ['悬疑剧', '口碑崩塌', '烂尾争议'],
    views: 143200,
    comments: 6721,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '11',
    title: '某男团成员被爆与粉丝私联，经纪公司紧急回应',
    slug: 'nantuan-chengyuan-silian',
    excerpt: '当红男团成员被曝私下与多名女粉丝保持联系，其中涉及不当行为引发广泛关注。',
    content: `<p>近日，有自称是某当红男团成员"前女友"的网友在社交平台上曝光了大量聊天记录和照片，指控该男团成员在活动期间与多名女粉丝保持私下联系，并存在不当行为。</p><p>曝光的聊天记录显示，该成员通过社交平台的私信功能与粉丝建立联系，随后发展为线下见面。据爆料者称，受害者不止她一人，该成员同时与多名粉丝保持这种关系。</p><p>此事一经曝光立即在粉丝圈引起轩然大波。该成员的后援会紧急发布声明，呼吁粉丝理性看待，等待官方回应。但大量粉丝表示极度失望，要求该成员退出组合。</p><p>经纪公司在事件发酵24小时后发布声明，表示正在核实相关情况，将对艺人进行严肃处理，并暂停其近期所有公开活动。</p>`,
    category: 'mingxing-bagua',
    author: '饭圈观察',
    publishedAt: '2026-07-31T12:45:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20male%20idol%20singer%20on%20stage%20performing%20with%20microphone%2C%20colorful%20concert%20lighting%2C%20fan%20light%20sticks%20in%20audience%2C%20emotional%20performance%20moment%2C%20dramatic%20stage%20atmosphere&width=800&height=533&seq=article-11&orientation=landscape',
    tags: ['男团成员', '粉丝私联', '不当行为'],
    views: 198700,
    comments: 8234,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '12',
    title: '知名导演被曝片场耍大牌，工作人员集体抗议',
    slug: 'zhiming-daoyan-shuadapai',
    excerpt: '多位剧组工作人员匿名爆料某知名导演在片场态度恶劣，甚至出现辱骂演员的情况。',
    content: `<p>一篇由多位匿名剧组工作人员联合投稿的文章近日在网络上引起广泛关注。文章详细描述了某获奖无数的大牌导演在片场的种种不当行为。</p><p>据爆料，该导演在拍摄期间经常对演员和工作人员进行人身攻击式的辱骂，动辄摔东西、骂人，甚至有工作人员因压力过大而选择辞职。一位化妆师在文章中写道："每一天去片场都像上刑场。"</p><p>文章还提到，该导演存在严重的"双标"行为——对一线明星态度恭敬，对配角和新演员则态度恶劣。这种区别对待让整个剧组氛围变得极其压抑。</p><p>目前，该导演尚未对此做出回应。不过，多位曾与其合作过的演员在接受采访时表示，不方便对同行的个人风格进行评论，但承认"每个导演的工作方式确实不同"。</p>`,
    category: 'yingshi-zixun',
    author: '片场故事',
    publishedAt: '2026-07-31T09:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20shouting%20on%20movie%20set%20with%20megaphone%2C%20crew%20members%20looking%20stressed%2C%20dramatic%20on%20set%20tension%2C%20behind%20the%20scenes%20documentary%20style%2C%20warm%20set%20lighting&width=800&height=533&seq=article-12&orientation=landscape',
    tags: ['导演耍大牌', '片场霸凌', '工作人员抗议'],
    views: 107300,
    comments: 3845,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '13',
    title: '短视频平台限制未成年人打赏功能全面升级',
    slug: 'weichengnianren-dashang-xianzhi',
    excerpt: '多家短视频平台宣布升级未成年人保护措施，包括严格打赏限制和青少年模式强制开启。',
    content: `<p>在国家相关部门的指导下，多家头部短视频平台近日同步宣布全面升级未成年人保护措施。新措施包括：默认开启青少年模式、严格限制未成年人打赏金额、禁止未成年人在夜间时段使用直播功能等。</p><p>此次升级的背景是近期多起未成年人巨额打赏事件引发的社会关注。上个月，一名12岁的女孩在短短一周内打赏主播超过20万元，引发了全社会对未成年人网络保护的讨论。</p><p>平台方表示，将采用更先进的人脸识别和AI技术来识别未成年用户，并在充值、打赏等关键环节设置多重验证。同时，对于诱导未成年人打赏的主播，将采取永久封禁等严厉措施。</p><p>教育专家对此表示欢迎，认为这是平台履行社会责任的积极举措，但也指出家长的教育和监管同样重要。</p>`,
    category: 'shehui-redian',
    author: '社会观察',
    publishedAt: '2026-07-30T16:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20teenager%20using%20smartphone%20with%20parental%20control%20interface%20on%20screen%2C%20modern%20living%20room%20setting%2C%20warm%20family%20atmosphere%2C%20digital%20safety%20concept%2C%20soft%20natural%20lighting&width=800&height=533&seq=article-13&orientation=landscape',
    tags: ['未成年人', '打赏限制', '平台升级'],
    views: 89100,
    comments: 3124,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '14',
    title: '某脱口秀演员因不当言论被封杀，节目连夜剪辑',
    slug: 'tuokouxiu-yanyuan-fengsha',
    excerpt: '一位当红脱口秀演员因在线下演出中发表不当言论被全网封杀，所有参演节目已紧急下架。',
    content: `<p>一位在喜剧圈颇具人气的脱口秀演员日前因在线下演出中涉及敏感话题和不当言论，遭到全网封杀处理。所有由其参演的综艺节目、网络内容已被紧急下架或剪辑。</p><p>据现场观众描述，该演员在即兴互动环节中，对一些社会话题发表了明显不当的评论，现场一度出现尴尬的气氛。相关视频片段被观众上传至网络后迅速发酵。</p><p>多个平台在第一时间做出了反应。该演员的所有作品在全网下架，其社交账号也被暂停使用。其所属的经纪公司发布声明，宣布已与该演员解除合约关系。</p><p>这起事件再次引发了关于脱口秀内容边界的讨论。有观点认为，幽默应该有底线，不能为了追求笑果而触碰红线；也有观点认为，即兴表演中的失误不应被过度放大。</p>`,
    category: 'zongyi-jieMu',
    author: '综艺内幕',
    publishedAt: '2026-07-30T10:15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20stand%20up%20comedian%20on%20stage%20with%20microphone%20under%20spotlight%2C%20comedy%20club%20atmosphere%2C%20dramatic%20stage%20lighting%2C%20tense%20moment%20captured%2C%20warm%20wooden%20interior&width=800&height=533&seq=article-14&orientation=landscape',
    tags: ['脱口秀', '不当言论', '全网封杀'],
    views: 256800,
    comments: 10234,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '15',
    title: '网红城市打卡地涉嫌虚假宣传被责令整改',
    slug: 'wanghong-chengshi-xujia',
    excerpt: '多个在社交平台上爆红的所谓网红打卡地被曝光存在严重虚假宣传，实际情况与宣传图片差距巨大。',
    content: `<p>近期，多个被短视频和社交平台带火的"网红打卡地"被游客曝光存在严重虚假宣传问题。实际景观与网上流传的精修图片差距之大，让不少专程前往的游客大呼上当。</p><p>其中被投诉最多的是某城市新开的"天空之境"景区。在宣传图片中，该景区呈现出绝美的镜面效果，但实际上只是地面铺设了几块反光板，需要特定角度才能拍摄出类似效果。一位游客在投诉中写道："去了才知道，网上那些照片全是照骗。"</p><p>当地文化和旅游局已介入调查，责令相关景区立即整改宣传内容，并对虚假宣传行为进行处罚。同时，平台方也表示将加强对旅游类内容的审核力度。</p><p>业内人士提醒消费者，在选择旅游目的地时不要仅凭网络图片做决定，建议多渠道了解真实评价后再做规划。</p>`,
    category: 'shehui-redian',
    author: '真相调查',
    publishedAt: '2026-07-29T14:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tourist%20at%20scenic%20spot%20comparing%20real%20view%20with%20exaggerated%20social%20media%20photo%20on%20phone%2C%20disappointed%20expression%2C%20daylight%20outdoor%20scene%2C%20documentary%20style%2C%20natural%20lighting&width=800&height=533&seq=article-15&orientation=landscape',
    tags: ['网红打卡地', '虚假宣传', '责令整改'],
    views: 112500,
    comments: 4456,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '16',
    title: '某女团成员练习生时期霸凌视频被曝光',
    slug: 'nvtuan-baling-shipin',
    excerpt: '一段疑似当红女团成员练习生时期的霸凌视频在网上流传，所属公司已启动调查程序。',
    content: `<p>一段令人震惊的视频近日在网络上疯传。视频中，疑似某当红女团的某位成员在练习生时期对同期练习生进行言语和肢体上的霸凌行为。视频的真实性尚待确认，但已经在粉丝圈引发了地震般的反响。</p><p>被指控的成员所属的女团目前正处于回归宣传期，此事无疑给他们的回归计划蒙上了阴影。大量网友涌入该成员的社交账号评论区表达愤怒和失望，话题标签#抵制校园霸凌者#迅速登上热搜。</p><p>该女团所属的娱乐公司发表声明称，正在对视频的真实性进行调查，如果核实确有其事，将对涉事成员进行严肃处理。同时，公司也呼吁公众在调查结果出来之前保持理性。</p><p>这起事件也引发了韩国娱乐产业对练习生管理的反思。有前练习生在网上分享了自己的经历，指出练习生之间的竞争压力确实容易导致一些不健康的行为。</p>`,
    category: 'mingxing-bagua',
    author: '韩娱前线',
    publishedAt: '2026-07-29T20:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=K-pop%20girl%20group%20on%20stage%20performing%20colorful%20choreography%2C%20bright%20stage%20lights%2C%20professional%20concert%20photography%2C%20dynamic%20dance%20pose%2C%20Korean%20pop%20concert%20atmosphere&width=800&height=533&seq=article-16&orientation=landscape',
    tags: ['女团成员', '霸凌视频', '练习生'],
    views: 312400,
    comments: 12456,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '17',
    title: '知名文化博主与平台解约，千万粉丝何去何从',
    slug: 'wenhua-bozhu-jieyue',
    excerpt: '拥有千万粉丝的文化类博主突然宣布与平台解约，转战其他平台，引发内容创作者群体热议。',
    content: `<p>在知识付费和文化传播领域耕耘多年的知名博主"文化行者"突然宣布与当前平台解约，将全部内容迁移至另一新兴平台。这一决定让他的上千万粉丝感到意外。</p><p>据悉，解约的主要原因是双方在分成比例和内容审核标准上存在分歧。"文化行者"在告别长文中写道："一个不能让创作者自由表达和获得合理回报的平台，不值得继续留下。"</p><p>这次事件在内容创作者群体中引发了广泛共鸣。多位博主表示，当前各大平台对创作者的扶持力度和尊重程度确实有待提高。一位拥有500万粉丝的博主评论道："平台和创作者应该是合作伙伴，而不是剥削关系。"</p><p>业内人士分析认为，随着短视频平台竞争的加剧，优质创作者的话语权正在逐渐增强，"创作者经济"的去中心化趋势将越来越明显。</p>`,
    category: 'wanghong-redian',
    author: '创作者观察',
    publishedAt: '2026-07-28T13:45:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20content%20creator%20filming%20video%20with%20professional%20camera%20setup%20in%20modern%20home%20studio%2C%20bookshelves%20background%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20atmosphere&width=800&height=533&seq=article-17&orientation=landscape',
    tags: ['博主解约', '平台迁徙', '创作者经济'],
    views: 76300,
    comments: 2891,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '18',
    title: '某知名游戏主播涉嫌赌博被警方带走调查',
    slug: 'youxi-zhubo-dubo-diaocha',
    excerpt: '一位在游戏直播圈拥有极高人气的主播因涉嫌参与网络赌博被警方带走调查，直播间已被永久关闭。',
    content: `<p>游戏直播圈再爆重磅新闻。拥有数百万粉丝的知名游戏主播"战神"因涉嫌参与和组织网络赌博活动，已被警方依法带走调查。其所在直播平台已紧急关闭了该主播的直播间，并发布声明表示配合警方调查。</p><p>据知情人士透露，该主播在直播过程中会引导观众前往第三方平台进行虚拟物品抽奖，而这些抽奖活动实际上具有赌博性质。警方在接到举报后经过长期侦查，最终在昨日实施了抓捕行动。</p><p>这并非游戏直播圈第一次出现类似事件。去年，就曾有数位游戏主播因类似问题被查处。有评论人士指出，直播平台应对主播的推广内容承担更多监管责任。</p><p>目前该案件仍在进一步调查中。法律专家表示，如果罪名成立，该主播可能面临数年有期徒刑。</p>`,
    category: 'wanghong-redian',
    author: '游戏前线',
    publishedAt: '2026-07-28T08:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20studio%20setup%20with%20multiple%20monitors%20and%20RGB%20lighting%2C%20empty%20gaming%20chair%2C%20dark%20room%20with%20police%20tape%20around%2C%20dramatic%20lighting%2C%20investigation%20scene&width=800&height=533&seq=article-18&orientation=landscape',
    tags: ['游戏主播', '网络赌博', '警方调查'],
    views: 289300,
    comments: 13452,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '19',
    title: '暑期档票房大战白热化：三部国产大片同天上映',
    slug: 'shuqi-dang-piaofang-dazhan',
    excerpt: '今年暑期档迎来最激烈的票房争夺战，三部备受期待的国产大片选择同天上映。',
    content: `<p>2026年暑期档迎来最激烈的票房争夺战。三部投资过亿的国产大片不约而同选择在8月8日同天上映，被业内称为"史上最卷暑期档"。</p><p>三部影片分别是科幻巨制《星际迷途》、动作喜剧《王牌保镖2》和文艺剧情片《漫长的告别》。三部影片风格迥异，目标受众各有侧重，但同天上映无疑会分摊排片和票房。</p><p>影院排片经理们面临艰难抉择。一位从业15年的排片经理表示："这是近十年来最纠结的一次排片，三部片子质量都很高，但银幕就这么多。"</p><p>目前《星际迷途》的预售票房暂时领先，但《王牌保镖2》的想看人数增长最快。业内预测，最终票房冠军可能在15亿到20亿之间。</p>`,
    category: 'yingshi-zixun',
    author: '票房观察',
    publishedAt: '2026-07-27T17:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20theater%20exterior%20with%20large%20film%20posters%20and%20crowded%20entrance%2C%20summer%20blockbuster%20season%2C%20bright%20daylight%2C%20cinema%20box%20office%20atmosphere%2C%20energetic%20crowd&width=800&height=533&seq=article-19&orientation=landscape',
    tags: ['暑期档', '票房大战', '国产大片'],
    views: 98100,
    comments: 3124,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '20',
    title: '某艺人工作室被曝偷税漏税，税务部门介入调查',
    slug: 'yiren-gongzuoshi-toushui',
    excerpt: '知名艺人工作室被举报存在偷税漏税问题，当地税务部门已正式介入调查。',
    content: `<p>继前几年娱乐圈税务风波后，又一位知名艺人的工作室被曝存在税务问题。据举报材料显示，该艺人工作室在2023年至2025年期间，涉嫌通过虚假合同、阴阳合同等方式逃避税款，金额可能高达数千万元。</p><p>当地税务部门回应称，已经收到相关举报材料并正式立案调查。如果举报内容属实，该艺人将面临补缴税款、罚款甚至刑事处罚。</p><p>该艺人的工作室随后发布声明，称所有税务申报均合法合规，愿意配合税务部门的调查工作。声明中还表示，将对发布不实信息的行为保留追究法律责任的权利。</p><p>这起事件再次让公众关注到娱乐圈的税务问题。自前几年的税务大整顿以来，虽然行业整体合规意识有所提升，但仍有少数人存在侥幸心理。</p>`,
    category: 'mingxing-bagua',
    author: '财经观察',
    publishedAt: '2026-07-27T11:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20agent%20office%20building%20exterior%2C%20modern%20glass%20architecture%2C%20serious%20business%20atmosphere%2C%20tax%20document%20theme%2C%20professional%20corporate%20photography%2C%20overcast%20day&width=800&height=533&seq=article-20&orientation=landscape',
    tags: ['偷税漏税', '税务调查', '艺人工作室'],
    views: 224600,
    comments: 7823,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '21',
    title: '某网红餐饮品牌大规模关店，加盟商集体维权',
    slug: 'wanghong-canyin-guanDian',
    excerpt: '曾红极一时的网红餐饮品牌被曝大规模关店，数百名加盟商损失惨重，已联合发起维权行动。',
    content: `<p>曾经在全国拥有超过500家门店的网红餐饮品牌"茶颜欢"近日被曝出现大规模关店潮。据不完全统计，仅本月就有超过60家门店关门歇业，大量加盟商血本无归。</p><p>一位投资了3家门店的加盟商在维权群中表示："品牌方承诺的扶持政策一个都没兑现，物料价格比市场价高出三倍，再加上品牌口碑下滑，根本撑不下去。"</p><p>更令加盟商愤怒的是，品牌方至今未对关店潮做出合理解释，总部电话也长期无人接听。目前，来自全国各地的200多名加盟商已联合委托律师事务所，准备发起集体诉讼。</p><p>这起事件为网红餐饮加盟模式敲响了警钟。业内人士建议，创业者在选择加盟品牌时应保持理性，不要被表面的火爆现象所迷惑。</p>`,
    category: 'shehui-redian',
    author: '财经调查',
    publishedAt: '2026-07-26T19:15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Closed%20Chinese%20bubble%20tea%20shop%20with%20shuttered%20doors%20and%20for%20lease%20sign%2C%20empty%20street%20view%2C%20abandoned%20commercial%20storefront%2C%20sad%20urban%20scene%2C%20daylight%20documentary%20photography&width=800&height=533&seq=article-21&orientation=landscape',
    tags: ['网红餐饮', '大规模关店', '加盟商维权'],
    views: 134200,
    comments: 5689,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '22',
    title: '某配音演员因私生活争议被多部作品换角',
    slug: 'peiyin-yanyuan-huanjue',
    excerpt: '一位知名配音演员因被曝私生活混乱，导致其参与的多部作品紧急换人，损失巨大。',
    content: `<p>配音圈近日发生了一起震动业界的事件。一位业内颇有名气的配音演员因被前女友爆料私生活混乱，同时与多人保持恋爱关系，导致其参与的多部在制作品紧急宣布更换配音演员。</p><p>该配音演员此前为多部热门动画和游戏作品配音，拥有大量粉丝。此次事件曝光后，粉丝群体迅速分裂为两派，一派认为私德与专业能力应该分开看待，另一派则认为公众人物应该承担更高的道德标准。</p><p>多个制作方表示，考虑到作品的市场接受度和品牌形象，决定临时更换配音演员。据估算，仅换人带来的重录成本就高达数百万元。</p><p>该配音演员本人已发布道歉声明，承认在感情处理上不够成熟，但否认了部分更严重的指控。声明中表示将暂时停止公开活动，进行深刻反思。</p>`,
    category: 'mingxing-bagua',
    author: '声优前线',
    publishedAt: '2026-07-26T14:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20voice%20actor%20in%20recording%20studio%20with%20microphone%20and%20soundproof%20panels%2C%20professional%20audio%20equipment%2C%20dramatic%20studio%20lighting%2C%20behind%20the%20scenes%20documentary&width=800&height=533&seq=article-22&orientation=landscape',
    tags: ['配音演员', '私生活争议', '作品换角'],
    views: 87300,
    comments: 3456,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '23',
    title: '某综艺节目选手因不满评分现场发飙罢录',
    slug: 'zongyi-xuanshou-balu',
    excerpt: '选秀节目录制现场发生戏剧性一幕，一位选手因不满导师评分当场发飙并拒绝继续录制。',
    content: `<p>某选秀节目的最新一期录制现场发生了前所未有的一幕。一位选手在听到导师给出的低分后情绪失控，当场扔掉话筒并表示拒绝继续参加录制。这一突发状况让现场陷入了极度尴尬的气氛。</p><p>据在场观众透露，该选手在此前的几轮表现中都获得了不错的评价，但本轮表演确实存在明显瑕疵。三位导师给出的评分均在及格线以下，这在赛程进入后半段的激烈竞争中无疑是致命一击。</p><p>节目组立即暂停录制，工作人员上前安抚该选手的情绪。经过近一个小时的沟通，该选手最终决定退出比赛。节目组表示尊重选手的决定，并已安排了替补方案。</p><p>此事在网络上引发热议。有网友认为选手反应过度，缺乏职业素养；也有网友表示理解，认为比赛压力太大确实容易让人崩溃。</p>`,
    category: 'zongyi-jieMu',
    author: '选秀观察',
    publishedAt: '2026-07-25T16:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20contestant%20throwing%20microphone%20on%20stage%2C%20judges%20shocked%20expressions%2C%20dramatic%20studio%20lighting%2C%20reality%20show%20drama%20moment%2C%20intense%20atmosphere&width=800&height=533&seq=article-23&orientation=landscape',
    tags: ['选秀节目', '选手发飙', '现场罢录'],
    views: 167400,
    comments: 6123,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '24',
    title: '某短视频创作者因抄袭国外博主被集体取关',
    slug: 'duan-shipin-chaoxi',
    excerpt: '一位拥有300万粉丝的短视频创作者被网友扒出大量内容抄袭国外博主，粉丝数暴跌。',
    content: `<p>近日，一位拥有300万粉丝的短视频创作者遭遇了严重的信任危机。有网友通过详细比对发现，该创作者近一年来发布的超过70%的内容，都与国外某知名博主的作品高度相似，从选题、分镜到文案几乎如出一辙。</p><p>对比视频被制作成合集发布后，在网络上迅速传播开来。大量粉丝表示感到被欺骗，纷纷取关。该创作者的粉丝数在48小时内从310万骤降至180万，跌幅超过40%。</p><p>该创作者随后发布了一条道歉视频，承认在创作过程中"不够原创"，并表示将删除所有争议内容，重新开始原创创作。但这一回应被很多人认为不够诚恳。</p><p>此次事件也引发了关于短视频行业原创性问题的广泛讨论。平台方表示，将加强对抄袭行为的打击力度，保护原创内容创作者的权益。</p>`,
    category: 'wanghong-redian',
    author: '原创观察',
    publishedAt: '2026-07-25T10:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20content%20creator%20looking%20at%20two%20screens%20showing%20identical%20video%20content%2C%20plagiarism%20comparison%2C%20worried%20expression%2C%20modern%20studio%20setup%2C%20dramatic%20lighting&width=800&height=533&seq=article-24&orientation=landscape',
    tags: ['抄袭国外博主', '集体取关', '粉丝暴跌'],
    views: 123500,
    comments: 4567,
    isHot: false,
    isFeatured: false,
  },
];